export const init_centro_log_location = "/centro_log";
export const url_centro_log_dashboard = `${init_centro_log_location}/dashboard`;
export const url_centro_log_entrances = `${init_centro_log_location}/entrances`;
export const url_centro_log_logistics = `${init_centro_log_location}/logistics`;
export const url_centro_log_movements = `${init_centro_log_location}/movements`;
export const url_centro_log_stock = `${init_centro_log_location}/stock`;
export const url_centro_log_search = `${init_centro_log_location}/search`;
